import { type SubmitHandler, useForm } from 'react-hook-form';

import {
    Description,
    Dialog,
    DialogBody,
    DialogCloseButton,
    DialogFooter,
    DialogHeader,
    Form,
    Heading,
    Submit,
    TextField,
    TextInput,
    useDialogClose,
} from '@gitbook/spine-react';

type EditAltTextFormInputs = {
    alt: string;
};

export function EditAltTextDialog(props: {
    defaultValue: string;
    onChange: (value: string) => void;
}) {
    return (
        <Dialog>
            <EditAltTextForm {...props} />
        </Dialog>
    );
}

function EditAltTextForm(props: { defaultValue: string; onChange: (value: string) => void }) {
    const close = useDialogClose();
    const form = useForm<EditAltTextFormInputs>({ defaultValues: { alt: props.defaultValue } });
    const onSubmit: SubmitHandler<EditAltTextFormInputs> = (data) => {
        props.onChange(data.alt);
        close();
    };
    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)}>
            <DialogHeader>
                <Heading>Edit alt text</Heading>
            </DialogHeader>
            <DialogBody>
                <TextField name="alt">
                    <TextInput autoFocus placeholder="Text replacement for image" />
                    <Description>
                        This will be read out by screen readers when the image is encountered.
                        Describe the image in detail – it's how visually impaired readers know
                        what's in front of them.
                    </Description>
                </TextField>
            </DialogBody>
            <DialogFooter>
                <DialogCloseButton />
                <Submit label="Save" />
            </DialogFooter>
        </Form>
    );
}
